<!--
 * File: cc-cell-item-variant-selector.component.html                          *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 25th May 2022 13:51:32                             *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 27th May 2022 10:06:50                               *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 -->

 <p-button
  class="n-button-icon"
  icon="fa fa-hand-pointer"
  size="small"
  severity="info"
  [raised]="true"
  (onClick)="productVariant.toggle($event)"
  aria-label="Model type product"
  styleClass="n-button-icon-xs"
  [pTooltip]="'Variantes'"
  [tooltipPosition]="'top'"
  [disabled]="!variants || variants.length == 0"
  ></p-button>


<p-menu #productVariant [popup]="true" [model]="variants">
  <!-- <mat-selection-list #shoes [multiple]="false">
    <mat-list-option
      *ngFor="let item of variants"
      (click)="changeVariant(item)"
    >
    
      <div  >
        <img
          src="{{ item.image }}"
          style="width: 32px; margin-right: 1em"
        />
        <span>{{ item.name }}</span>
      </div>
    </mat-list-option>
  </mat-selection-list> -->
</p-menu>
